enum FormsNameEnum {
    GadSevenEnglishCommon = "Form - GAD 7 - English - Common"
}

export { FormsNameEnum };
